import ServerList from '../components/ServerList';
import { useNavigate } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import { useServerList } from '../../../hooks/useServerList';
import { AppErrorList } from '../../../shared/components/AppErrorList';
import React from 'react';

const ServerListContainer = () => {
  const navigate = useNavigate();
  const [{ servers, isLoading, errors }] = useServerList();

  const handleSelectServer = (serverId: string) => {
    navigate(`/servers/${serverId}`);
  }

  if (isLoading) {
      return <CircularProgress size={20} />;
  }

  if (errors.length > 0) {
    return <AppErrorList errors={errors} />;
  }

  return (
    <ServerList
      servers={servers}
      onSelectServer={handleSelectServer}
    />
  );
}

export default ServerListContainer;
